import SessionStorageService from './../services/SessionStorageService';
import { GlobalConfigType } from '../types/GlobalConfigType';

class GlobalConfig {
  private globalConfig: GlobalConfigType | null = null;

  public val = (): GlobalConfigType => {
    const globalConfigJson = SessionStorageService.get('globalConfig');

    this.globalConfig = JSON.parse(globalConfigJson ? globalConfigJson : '');
    return this.globalConfig as GlobalConfigType;
  };
}

export default new GlobalConfig();
